import { Footer } from "../components/Footer";
import { Nav } from "../components/Nav";
import ServiceDetails from "../components/ServiceDetails";
import { Seo } from "../components/Seo";

export default function WaterWastewater() {
	return (
		<>
			<Seo title="Austin Water & Wastewater Engineering | Gova" description="Utility tap plans, water distribution, wastewater collection, and infrastructure coordination for Central Texas development." path="/water-wastewater" serviceName="Water and Wastewater Engineering" />
			<Nav />
			<ServiceDetails
				service="water-wastewater"
				onBack={() => window.history.back()}
			/>
			<Footer />
		</>
	);
}
